var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { ELogScope } from "./logScope";
export var EExportLogsFormat;
(function (EExportLogsFormat) {
    EExportLogsFormat["CSV"] = "CSV";
    EExportLogsFormat["SQL"] = "SQL";
    // The PDF arrives zipped.
    EExportLogsFormat["PDF"] = "PDF";
})(EExportLogsFormat || (EExportLogsFormat = {}));
/** What an export covers, as the export actions name it. */
export var EExportLogsScope;
(function (EExportLogsScope) {
    /** The whole tenant log. */
    EExportLogsScope["TENANT_LOG"] = "TENANT_LOG";
    /** One account's entries. */
    EExportLogsScope["ACCOUNT"] = "ACCOUNT";
    /** One account's entries in the tenant log and in every election event's log. */
    EExportLogsScope["ACCOUNT_WITH_EVENTS"] = "ACCOUNT_WITH_EVENTS";
    /** The whole election event. */
    EExportLogsScope["ALL"] = "ALL";
    EExportLogsScope["ELECTION"] = "ELECTION";
    EExportLogsScope["AREA"] = "AREA";
})(EExportLogsScope || (EExportLogsScope = {}));
var SCOPES = (_a = {},
    _a[ELogScope.TENANT] = [EExportLogsScope.TENANT_LOG, EExportLogsScope.ACCOUNT],
    _a[ELogScope.EVENT] = [
        EExportLogsScope.ALL,
        EExportLogsScope.ELECTION,
        EExportLogsScope.AREA,
        EExportLogsScope.ACCOUNT,
    ],
    _a);
/** The scopes the export dialog offers for a log; the first is its default. */
export var exportLogsScopes = function (log) { return SCOPES[log]; };
var ACCOUNT_SCOPES = [EExportLogsScope.ACCOUNT, EExportLogsScope.ACCOUNT_WITH_EVENTS];
export var isAccountScope = function (scope) { return ACCOUNT_SCOPES.includes(scope); };
/** One account of the tenant log, with or without its entries in every election event. */
export var tenantExportScope = function (scope, withElectionEvents) {
    return isAccountScope(scope)
        ? withElectionEvents
            ? EExportLogsScope.ACCOUNT_WITH_EVENTS
            : EExportLogsScope.ACCOUNT
        : scope;
};
/** Whether the scope has what it names: an account, an election or an area. */
export var exportScopeReady = function (_a) {
    var scope = _a.scope, username = _a.username, electionId = _a.electionId, areaId = _a.areaId;
    if (isAccountScope(scope))
        return !!username.trim();
    if (scope === EExportLogsScope.ELECTION)
        return !!electionId;
    if (scope === EExportLogsScope.AREA)
        return !!areaId;
    return true;
};
var usernameOf = function (_a) {
    var scope = _a.scope, username = _a.username;
    return isAccountScope(scope) ? username.trim() : null;
};
/** The variables of `export_tenant_logs`. */
export var tenantExportVariables = function (choice, format, range) { return (__assign({ format: format, scope: choice.scope, username: usernameOf(choice) }, range)); };
/** The variables of `export_election_event_logs`. */
export var eventExportVariables = function (electionEventId, choice, format, range) { return (__assign({ electionEventId: electionEventId, format: format, scope: choice.scope, electionId: choice.scope === EExportLogsScope.ELECTION ? choice.electionId : null, areaId: choice.scope === EExportLogsScope.AREA ? choice.areaId : null, username: usernameOf(choice) }, range)); };
